import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, Suspense as _Suspense, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 3,
  class: "main"
}
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = {
  id: "layout",
  class: "layout"
}
const _hoisted_4 = {
  key: 1,
  class: "text-h5 text-center px-4 m_color-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheCabinetOff = _resolveComponent("TheCabinetOff")!
  const _component_AppPageLoader = _resolveComponent("AppPageLoader")!
  const _component_BaseFlex = _resolveComponent("BaseFlex")!
  const _component_NewYearAlert = _resolveComponent("NewYearAlert")!
  const _component_AppInfoDialog = _resolveComponent("AppInfoDialog")!
  const _component_AppYellowModal = _resolveComponent("AppYellowModal")!
  const _component_BaseSkeleton = _resolveComponent("BaseSkeleton")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { id: "app" }, {
    default: _withCtx(() => [
      (_ctx.userCreateError)
        ? (_openBlock(), _createBlock(_component_TheCabinetOff, {
            key: 0,
            title: "Техническая ошибка",
            subtitle: `Возникла ошибка при создании пользователя add = ${_ctx.userCreateError.code} ${_ctx.userCreateError.time}, обратитесь в службу поддержки`,
            details: _ctx.userCreateError.message
          }, null, 8, ["subtitle", "details"]))
        : (!_ctx.isInitialized)
          ? (_openBlock(), _createBlock(_component_BaseFlex, {
              key: 1,
              class: "m_justify-center m_flex-grow1 m_align-center m_flex-column m_gap16"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AppPageLoader)
              ]),
              _: 1
            }))
          : (_ctx.fatalError)
            ? (_openBlock(), _createBlock(_component_TheCabinetOff, { key: 2 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "header"),
                    _renderSlot(_ctx.$slots, "banner"),
                    (!_ctx.$slots.banner)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: `wrapper_${_ctx.hasActiveCard}`,
                          class: _normalizeClass(["layout__wrapper", { 'layout__wrapper--with-card': _ctx.hasActiveCard }])
                        }, [
                          (_ctx.isShowNavbar)
                            ? _renderSlot(_ctx.$slots, "navbar", { key: 0 })
                            : _createCommentVNode("", true),
                          (_ctx.error || _ctx.isCapturedError)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('general.error_occured')) + ". " + _toDisplayString(_ctx.$t('general.try_again')), 1))
                            : _renderSlot(_ctx.$slots, "main", { key: 2 })
                        ], 2))
                      : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "footer")
                  ])
                ])
              ])),
      (_ctx.isInitialized)
        ? (_openBlock(), _createBlock(_component_NewYearAlert, { key: 4 }))
        : _createCommentVNode("", true),
      _createVNode(_component_AppInfoDialog),
      _createVNode(_component_AppYellowModal),
      _createVNode(_component_BaseDialog, {
        modelValue: _ctx.productInModalOpened,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productInModalOpened) = $event)),
        "content-width": "1140px",
        "onClick:outside": _ctx.onCloseProduct
      }, {
        default: _withCtx(() => [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.productInModalOpened)
                ? (_openBlock(), _createBlock(_component_BaseCard, {
                    key: 0,
                    class: "m_bg-white m_pa16 m_pt8"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_Suspense, null, {
                        fallback: _withCtx(() => [
                          _createVNode(_component_BaseSkeleton, {
                            type: "image",
                            height: "400"
                          })
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$options.AppProductPageAsync), {
                            key: `product-in-modal-${_ctx.productInModalId}`,
                            "is-in-modal": "",
                            "product-id": _ctx.productInModalId,
                            onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.productInModalOpened = false))
                          }, null, 40, ["product-id"]))
                        ]),
                        _: 1
                      }))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onClick:outside"])
    ]),
    _: 3
  }))
}